import { emoteVis } from "@/animations/emote";
import { canv } from "@/canv/global";
import { randomIntFromInterval } from "@/canv/utils";
import { toolBase } from "@/tools/toolBase";

let DRAW_ERROR_LOGGED = false;

const EMOTE_ANIMATION_DELAY = 130;
const DEFAULT_EMOTE_SIZE = 50;

export class emoteTool extends toolBase {
    constructor() {
        super();

        this.emotes = [
            "/api/v2/static/media/emote/emote1.png",
            "/api/v2/static/media/emote/emote2.png",
            "/api/v2/static/media/emote/emote3.png",
            "/api/v2/static/media/emote/emote4.png",
            "/api/v2/static/media/emote/emote5.png",
        ];

        this.emotePath = this.emotes[0];
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.573 5.41114C19.1218 4.96386 18.5858 4.60896 17.9955 4.36681C17.4052 4.12465 16.7724 4 16.1332 4C15.4941 4 14.8612 4.12465 14.2709 4.36681C13.6807 4.60896 13.1446 4.96386 12.6934 5.41114L12.001 6.10415L11.3085 5.41114C10.8574 4.96386 10.3213 4.60896 9.73101 4.36681C9.14073 4.12465 8.50788 4 7.86874 4C7.2296 4 6.59675 4.12465 6.00647 4.36681C5.4162 4.60896 4.88011 4.96386 4.42896 5.41114C2.52246 7.29472 2.40556 10.4755 4.80666 12.8922L12.001 20L19.1953 12.8922C21.5964 10.4755 21.4795 7.29472 19.573 5.41114Z" stroke="#2C2D32" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Реакции";
    }

    select() {
        super.select();
        this.openSubMenu();
    }

    unselect() {
        super.unselect();
        this.closeSubMenu();

        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    openSubMenu() {
        const subMenu = document.createElement("div");
        subMenu.classList.add("emoteTool_subMenu");
        document.body.prepend(subMenu);

        let template = ``;

        for (let i = 0; i < this.emotes.length; i++) {
            const url = this.getEmoteUrl(this.emotes[i]);
            const additionalClass =
                this.emotePath === this.emotes[i] ? "emoteTool_subMenu_container_selected" : "";

            template += `<div class="emoteTool_subMenu_container ${additionalClass}" emotePath="${url}">
                <img src="${url}" />
            </div>`;
        }

        subMenu.innerHTML = template;

        const menuCallback = this.setEmotePath.bind(this);
        subMenu.addEventListener("mouseup", menuCallback);
        this.menuCallback = menuCallback;

        const emoteTool = document.querySelector(".emoteTool_subMenu") as HTMLDivElement;
        const toolBoxWrapper = document.querySelector(".toolBoxWrapper") as HTMLDivElement;
        const toolBoxWrapperSize = toolBoxWrapper.getBoundingClientRect();
        const emoteToolSize = emoteTool.getBoundingClientRect();

        const emoteToolTopValue =
            toolBoxWrapperSize.top + (toolBoxWrapperSize.height - emoteToolSize.height);
        emoteTool.style.top = `${emoteToolTopValue}px`;

        subMenu.style.transform = "translate(0px)";
        subMenu.style.opacity = "1";

        const img = new Image();
        img.src = this.getEmoteUrl(this.emotePath);

        img.onload = this.emoteOnLoad.bind(this, img);
    }

    closeSubMenu() {
        const subMenu = document.querySelector(".emoteTool_subMenu") as HTMLDivElement;

        if (this.menuCallback) {
            subMenu.removeEventListener("mouseup", this.menuCallback);
            this.menuCallback = null;
        }

        subMenu.outerHTML = "";
    }

    getEmoteUrl(src: string) {
        return `https://${canv.getInitDataProp("appDomain")}${src}`;
    }

    animateEmote(startX: number, startY: number) {
        const count = randomIntFromInterval(1, 3);

        for (let i = 0; i < count; i++) {
            const url = this.getEmoteUrl(this.emotePath);
            const emote = new emoteVis(startX, startY, url);

            canv.intercom.sendEmoteMessage(startX, startY, url);
            canv.animator.addAnimation(emote);
        }

        this.timer = setTimeout(this.timerWork.bind(this), EMOTE_ANIMATION_DELAY);
    }

    TryAction(type: string) {
        if (type === "mousedown") {
            this.mouseDown = true;

            const pt = canv.actionManager.getActionPoint();

            const creationStartX = pt.x;
            const creationStartY = pt.y;

            this.animateEmote(creationStartX, creationStartY);
        } else if (type === "mouseup") {
            this.mouseDown = false;
        }

        canv.redraw();
    }

    draw() {
        if (!this.mouseDown && this.emoteAvatar != null) {
            const pt = canv.actionManager.getActionPoint();

            const creationStartX = pt.x;
            const creationStartY = pt.y;

            try {
                canv.ctx.drawImage(
                    this.emoteAvatar,
                    creationStartX,
                    creationStartY,
                    (DEFAULT_EMOTE_SIZE / canv.m[0]) * canv.dpr,
                    (DEFAULT_EMOTE_SIZE / canv.m[0]) * canv.dpr,
                );
            } catch (e) {
                if (!DRAW_ERROR_LOGGED) {
                    DRAW_ERROR_LOGGED = true;
                    canv.captureException(e);
                }
            }
        }
    }

    timerWork() {
        if (this.mouseDown) {
            const pt = canv.actionManager.getActionPoint();

            const creationStartX = pt.x;
            const creationStartY = pt.y;

            this.animateEmote(creationStartX, creationStartY);
        }
    }

    setEmotePath(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const closestEmote = target.closest(
            ".emoteTool_subMenu_container",
        ) as HTMLDivElement | null;

        if (!closestEmote) {
            return;
        }

        const path = closestEmote.getAttribute("emotePath") as string;
        const img = new Image();
        this.emotePath = path.replace(`https://${canv.getInitDataProp("appDomain")}`, "");
        img.src = path;

        img.onload = this.emoteOnLoad.bind(this, img);

        const emotes = document.querySelectorAll(".emoteTool_subMenu_container");
        emotes.forEach((emote) => {
            const currentEmotePath = emote.getAttribute("emotePath");

            if (path === currentEmotePath) {
                emote.classList.add("emoteTool_subMenu_container_selected");

                return;
            }

            emote.classList.remove("emoteTool_subMenu_container_selected");
        });
    }

    emoteOnLoad(img: HTMLImageElement) {
        this.emoteAvatar = img;
    }

    name = "emoteTool";
    mouseDown = false;
    emotes: string[] = [];
    emotePath = "";
    emoteAvatar: HTMLImageElement | null = null;
    timer: NodeJS.Timeout | null = null;
    menuCallback: ((event: MouseEvent) => void) | null = null;
}
